import _ from 'underscore';
import getConfig from 'next/config';

const {
	publicRuntimeConfig: { basePath }
} = getConfig();

const liveLinks = [
	'/streaming-platforms',
	'/streaming-platform',
	'/broadcast',
	'/cinema/movies',
	'/lectures/movies',
	'/music/concerts',
	'/theaters/performances',
	'/archive',
	'/schedule',
	'/national-streaming',
	'/national-streaming/archive',
	'/national-streaming/schedule',
	'/movies'
];

export const isLiveLink = (url = '') =>
	_(liveLinks).some((partLink) => {
		const regexp = new RegExp(`^${partLink}([\\/\\?]|$)`);

		return regexp.test(url);
	}) || url === '/';

const basePathRegexp = new RegExp(`^${basePath}`);

export const urlWithoutBasePath = (url = '') =>
	url.replace(basePathRegexp, '') || '/';
